import moment from 'moment';

export const ranges = (showWeekForward = false) => {
  const currentDate = moment();
  const currentMonth = currentDate.month() + 1;

  const isQuarterAvailable = (quarterEndMonth) =>
    currentMonth > quarterEndMonth;

  return [
    {
      id: 1,
      name: 'Сегодня',
      range: [moment(), moment()],
    },
    {
      id: 2,
      name: 'Вчера',
      range: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    },
    {
      id: 4,
      name: 'Неделя',
      range: [moment().subtract(6, 'days'), moment()],
      icon: 'fast-backward',
    },
    {
      id: 5,
      name: 'Месяц',
      range: [moment().subtract(1, 'month').add(1, 'days'), moment()],
      icon: 'fast-backward',
    },
    {
      id: 6,
      name: '3 месяца',
      range: [moment().subtract(3, 'month').add(1, 'days'), moment()],
      icon: 'fast-backward',
    },
    {
      id: 7,
      name: 'Год',
      range: [moment().subtract(1, 'year').add(1, 'days'), moment()],
      icon: 'fast-backward',
    },
    {
      id: 8,
      name: 'Эта неделя',
      range: [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    },
    {
      id: 9,
      name: 'Этот месяц',
      range: [moment().startOf('month'), moment().endOf('month')],
    },
    {
      id: 10,
      name: 'Этот год',
      range: [moment().startOf('year'), moment().endOf('year')],
    },
    {
      id: 11,
      name: 'Все время',
      range: [moment('1000-01-01'), moment('3000-01-01')],
    },
    isQuarterAvailable(3) && {
      id: 12,
      name: '1 квартал',
      range: [moment().startOf('year'), moment().month(2).endOf('month')],
    },
    isQuarterAvailable(6) && {
      id: 13,
      name: '2 квартал',
      range: [
        moment().month(3).startOf('month'),
        moment().month(5).endOf('month'),
      ],
    },
    isQuarterAvailable(9) && {
      id: 14,
      name: '3 квартал',
      range: [
        moment().month(6).startOf('month'),
        moment().month(8).endOf('month'),
      ],
    },
    isQuarterAvailable(12) && {
      id: 15,
      name: '4 квартал',
      range: [
        moment().month(9).startOf('month'),
        moment().month(11).endOf('month'),
      ],
    },
    showWeekForward && {
      id: 16,
      name: 'Неделя вперед',
      range: [moment(), moment().add(7, 'days')],
      icon: 'fast-forward',
    },
  ].filter(Boolean);
};
